import * as React from 'react';
import styles from './BreakupTable.css';
import cx from 'classnames';
import { Value } from './Columns';
import { get } from 'lodash';
const Row = (props) => {
    const { offer = false, total = false, className } = props;
    const classname = cx({ [styles['green-text']]: offer }, { [styles['total-row']]: total }, className, styles['table-row']);
    let { children } = props;
    if (!children) {
        return null;
    }
    // This flag figures out whether we need to show the row or not. Later in the
    // `map` iteration, we check (based on the component of Value) the amount being
    // greater than zero.
    // TODO: a global variable that gets modified inside a map is hard to
    // understand clearly. Figure out a better way.
    let shouldShow = true;
    children = React.Children.map(children, child => {
        if (!React.isValidElement(child))
            return child;
        if (child.type === Value) {
            // If both raw amount and amount str are falsey values, skip this row entirely.
            const keepIfZero = get(child, 'props.keepIfZero', false);
            const rawAmount = Number(get(child, 'props.rawAmount', 0));
            const amountStr = get(child, 'props.amountStr', '');
            // If the column is set to not show when the value is zero, then skip showing
            // the entire row!
            // TODO: Should string '0' also be checked for this?
            if (rawAmount === 0 && amountStr === '') {
                shouldShow = keepIfZero;
            }
        }
        if (!total)
            return child;
        const className = styles['total-column'];
        return React.cloneElement(child, { className });
    });
    if (!shouldShow) {
        return null;
    }
    return <tr className={classname}>{children}</tr>;
};
export default Row;
